/**
 * Role-aware guard. Use AFTER RequireAuth.
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { Role } from '@vari-crew/schemas';
import { useCurrentUser } from './useCurrentUser';

export function RequireRole({
  roles,
  children,
}: {
  roles: Role[];
  children: ReactNode;
}) {
  const { data: me, isLoading } = useCurrentUser();
  if (isLoading || !me) return null;
  if (!roles.includes(me.role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
